"use client";

import { useEffect, useRef } from "react";
import { useClaritySession } from "@/lib/auth/auth-store";
import { identifyUser, setSuperProperties, resetAnalytics } from "./mixpanel";

export function useInitializeAnalytics(): void {
  const session = useClaritySession();
  const identifiedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (session.status === "authenticated") {
      const userId =
        typeof session.claims.sub === "string" ? session.claims.sub : "";

      if (!userId || identifiedUserIdRef.current === userId) return;

      identifiedUserIdRef.current = userId;

      const userProps: Record<string, unknown> = {};

      if (typeof session.claims.email === "string") {
        userProps.$email = session.claims.email;
      }
      if (typeof session.claims.name === "string") {
        userProps.$name = session.claims.name;
      }

      identifyUser(userId, userProps);

      setSuperProperties({
        env: process.env.NEXT_PUBLIC_ENVIRONMENT ?? process.env.NODE_ENV,
        app_version: process.env.NEXT_PUBLIC_RELEASE_VERSION,
      });

      return;
    }

    if (session.status === "signed_out") {
      identifiedUserIdRef.current = null;
      resetAnalytics();
    }
  }, [session]);
}
